import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiMenuAlt3, HiX } from 'react-icons/hi';
import { FaSun, FaMoon, FaPhoneAlt, FaEnvelope, FaRegClock } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../assets/images/logo/logo-green.png';
import './Navbar.css';

const navLinks = [
  { path: '/', label: 'Home' },
  { path: '/products', label: 'Products' },
  { path: '/branches', label: 'Our Branches' },
  { path: '/gallery', label: 'Gallery' },
  { path: '/about', label: 'About Us' },
  { path: '/contact', label: 'Contact Us' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__utility">
        <div className="container navbar__utility-inner">
          <a href="tel:+63495087899" className="navbar__utility-item">
            <FaPhoneAlt aria-hidden="true" />
            <span>+63-49-508-7899</span>
          </a>
          <a href="mailto:sales@tokyobyokane.com.ph" className="navbar__utility-item navbar__utility-item--email">
            <FaEnvelope aria-hidden="true" />
            <span>sales@tokyobyokane.com.ph</span>
          </a>
          <span className="navbar__utility-item navbar__utility-item--hours">
            <FaRegClock aria-hidden="true" />
            <span>Mon–Fri 8:00–17:00 PHT</span>
          </span>
        </div>
      </div>
      <div className="navbar__container container">
        <Link to="/" className="navbar__logo">
          <div className="navbar__logo-wrapper">
            <img src={logo} alt="Tokyo Byokane Philippines" />
          </div>
        </Link>

        <div className="navbar__right">
          <ul className={`navbar__links ${isOpen ? 'navbar__links--open' : ''}`}>
            {navLinks.map(({ path, label }) => (
              <li key={path}>
                <Link
                  to={path}
                  className={`navbar__link ${location.pathname === path ? 'navbar__link--active' : ''}`}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <button
            className="navbar__theme-toggle"
            onClick={toggleTheme}
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
            title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          >
            {theme === 'dark' ? <FaSun /> : <FaMoon />}
          </button>

          <button
            className="navbar__toggle"
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            {isOpen ? <HiX /> : <HiMenuAlt3 />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
